<template>
	<div id="MyVip">
		<div class="vip-box">
			<div class="vip-title">
				<div class="title-left">
					<img src="@/assets/images/vip/vip1.png" alt="">
					会员专属福利
				</div>
				<div class="title-right">
					VIP等级说明>>
				</div>
			</div>
			<p style="font-size: 12px; margin-left: 50px; color: #707694;">经验成长值:{{ user.vip_exp }}</p>
			<div class="vip-content">
				<div class="caption">
					<p>会员成长福利</p>
					<p>升级成长值</p>
					<!-- <p>会员专属权限</p> -->
					<p>会员惊喜加码</p>
					<p>会员升级礼包</p>
					<p>会员礼包领取</p>
				</div>
				<ul class="vip-info">
					<!--vip1-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-1.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">50</span>
						</div>
						<!-- <p>黑铁ROLL房</p> -->
						<p >充值+2%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">1</span>
						</div>
						<div class="award-receive" @click="AwardReceive(1)">
							<p v-if="IsReceivelevel(1) === true">已领取</p>
							<p v-else-if="vipLevel >= 1">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip2-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-2.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">200</span>
						</div>
						<!-- <p>黑铁ROLL房</p> -->
						<p>充值+2%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">3</span>
						</div>
						<div class="award-receive" @click="AwardReceive(2)">
							<p v-if="IsReceivelevel(2) === true">已领取</p>
							<p v-else-if="vipLevel >= 2">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip3-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-3.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">500</span>
						</div>
						<!-- <p>青铜ROLL房</p> -->
						<p>充值+3%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">10</span>
						</div>
						<div class="award-receive" @click="AwardReceive(3)">
							<p v-if="IsReceivelevel(3) === true">已领取</p>
							<p v-else-if="vipLevel >= 3">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip4-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-4.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">1000</span>
						</div>
						<!-- <p>青铜ROLL房</p> -->
						<p>充值+3%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">20</span>
						</div>
						<div class="award-receive" @click="AwardReceive(4)">
							<p v-if="IsReceivelevel(4) === true">已领取</p>
							<p v-else-if="vipLevel >= 4">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip5-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-5.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">2000</span>
						</div>
						<!-- <p>白银ROLL房</p> -->
						<p>充值+4%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">50</span>
						</div>
						<div class="award-receive" @click="AwardReceive(5)">
							<p v-if="IsReceivelevel(5) === true">已领取</p>
							<p v-else-if="vipLevel >= 5">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip6-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-6.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">3500</span>
						</div>
						<!-- <p>白银ROLL房</p> -->
						<p>充值+4%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">80</span>
						</div>
						<div class="award-receive" @click="AwardReceive(6)">
							<p v-if="IsReceivelevel(6) === true">已领取</p>
							<p v-else-if="vipLevel >= 6">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip7-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-7.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">5000</span>
						</div>
						<!-- <p>白银ROLL房</p> -->
						<p>充值+5%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">120</span>
						</div>
						<div class="award-receive" @click="AwardReceive(7)">
							<p v-if="IsReceivelevel(7) === true">已领取</p>
							<p v-else-if="vipLevel >= 7">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip8-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-8.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">7500</span>
						</div>
						<!-- <p>黄金ROLL房</p> -->
						<p>充值+6%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">200</span>
						</div>
						<div class="award-receive" @click="AwardReceive(8)">
							<p v-if="IsReceivelevel(8) === true">已领取</p>
							<p v-else-if="vipLevel >= 8">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip9-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-9.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">10000</span>
						</div>
						<!-- <p>黄金ROLL房</p> -->
						<p>充值+7%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">300</span>
						</div>
						<div class="award-receive" @click="AwardReceive(9)">
							<p v-if="IsReceivelevel(9) === true">已领取</p>
							<p v-else-if="vipLevel >= 9">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>
					<!--vip10-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-10.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">20000</span>
						</div>
						<!-- <p>黄金ROLL房</p> -->
						<p>充值+8%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">500</span>
						</div>
						<div class="award-receive" @click="AwardReceive(10)">
							<p v-if="IsReceivelevel(10) === true">已领取</p>
							<p v-else-if="vipLevel >= 10">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip11-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-11.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">35000</span>
						</div>
						<!-- <p>白金ROLL房</p> -->
						<p>充值+9%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">1000</span>
						</div>
						<div class="award-receive" @click="AwardReceive(11)">
							<p v-if="IsReceivelevel(11) === true">已领取</p>
							<p v-else-if="vipLevel >= 11">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>

					<!--vip12-->
					<li class="vip-info-li">
						<div class="vip-icon">
							<img src="@/assets/images/vip/VIP-12.png" alt="">
						</div>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">50000</span>
						</div>
						<!-- <p>钻石ROLL房</p> -->
						<p>充值+10%</p>
						<div class="vip-up-level">
							<img src="@/assets/images/vip/c_bi.png" alt="">
							<span style="font-family: Oxanium">1500</span>
						</div>
						<div class="award-receive" @click="AwardReceive(12)">
							<p v-if="IsReceivelevel(12) === true">已领取</p>
							<p v-else-if="vipLevel >= 12">领取</p>
							<p v-else>不可领取</p>
						</div>
					</li>
				</ul>
			</div>


			<div class="vip-desc">
				<span>Vip等级说明</span>
			</div>

			<div class="vip-tile">
				<div class="tile">
					<p>会员如何升级?</p>
				</div>
				<div class="info">
					<p>30天内满足对应级别成长值则可升级到对应会员级别。充值1c币=1成长值。</p>
				</div>
			</div>

			<div class="vip-tile">
				<div class="tile">
					<p>会员是否可以越级升级？</p>
				</div>
				<div class="info">
					<p>会员累计充值额度满足该会员级别条件，自动升级至该额度最高会员级别。</p>
					<p>例如：单笔充值500c币，则直接达到VIP3级别。</p>

				</div>
			</div>

			<div class="vip-tile">
				<div class="tile">
					<p>专属红包如何领取？</p>
				</div>
				<div class="info">
					<p>VIP升级后可领取当前级别的专属红包奖励，单用户限领1次，如降级后再次回到该级别则无法再次领取专属红包。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VipAward, VipAwardInfo, PersonalInfo } from '@/network/api.js'
import {
	mapState,
	mapMutations
} from 'vuex'

export default {
	name: 'MyVip',
	data() {
		return {
			ReceiveList: [],//领取过去奖励
			vipLevel: 0
		}
	},

	created() {
		this.GetVipAwardInfo();
	},

	methods: {
		AwardReceive(level) {
			VipAward(level).then((res) => {
				this.$message({
					message: res.data.message,
					type: 'success'
				})

				this.GetPersonalInfo();///刷新金币
				this.GetVipAwardInfo();///刷新领取状态
			})
		},

		///是否领取vip等级奖励
		IsReceivelevel(level) {
			for (let i = 0; i < this.ReceiveList.length; i++) {
				if (this.ReceiveList[i].vip_award == level)
					return true;
			}
			return false;
		},

		GetVipAwardInfo() {
			VipAwardInfo().then((res) => {
				this.ReceiveList = res.data.data.receive_list.data;
				this.vipLevel = res.data.data.vipLevel;
			})
		},

		GetPersonalInfo() {
			PersonalInfo().then((res) => {
				this.User(res.data.message)
			})
		},

		...mapMutations([
			'User'
		])

	},
	computed: {
		...mapState([
			'user'
		])
	}



}
</script>

<style lang="scss">
.vip-box {
	user-select: none;
	width: 100%;
	margin: 0 auto;
	background-color: #151723;

	.vip-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 80px;

		.title-left {
			display: flex;
			align-items: center;
			font-size: 18px;
			color: #fff;
			font-weight: 600;
			
		}

		.title-right {
			color: #707694;
		}
	}

	.vip-content {
		width: 100%;
		background-color: #12141F;
		
		.caption {
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			color: #707694;
			font-size: 10px;
			margin-left: 50px;
			margin-right: 50px;
		}

		.vip-info {
			font-family: 'Oxanium';
			border-top: 1px solid hsla(0, 0%, 100%, .08);
			width: 100%;
			display: grid;
			grid-template-columns: repeat(1, 1fr);
			grid-gap: 10px 16px;

			.vip-info-li {
				padding-left: 50px;	
				padding-right: 50px;
				height: 62px;
				overflow: hidden;
				border: 1px solid transparent;
				background-color: #0F111C;
				border-radius: 4px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.vip-icon {
					flex-shrink: 0;
					height: 100%;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.vip-up-level {
					flex-shrink: 0;
					display: flex;
					align-items: center;
					color: #f5d000;
					height: 62px;
					width: 62px;
					font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
					font-size: 15px;

					img {
						width: 40%;
						height: 40%;
					}
				}

				.award-receive {
					cursor: pointer;
					width: 80px;
					height: 30px;
					display: flex;
					justify-content: center;
					align-items: center;
	
					background-image: linear-gradient(90deg, #6f5a39, #6f4c2c);
					border-radius: 4px;
					border: 1px solid #dcae64;
					user-select: none;
					transition: all .3s ease;
					&:hover {
						background-image: linear-gradient(90deg, #6f5a39, #47321d);
					}

					p {
						margin-top: 5px;
						color: #ffffff;
						font-size: 12px;
					}
				}
			}
		}
	}

	.vip-desc {
		margin-left: 20px;
		margin-top: 30px;
		font-size: 34px;
		color: rgb(233, 233, 233);

		img {
			width: 50px;
			height: 50px;
		}
	}

	.vip-tile {
		margin-top: 30px;
		margin-left: 20px;

		.tile {
			font-size: 26px;
			color: rgb(199, 199, 199);
			
		}

		.info {
			margin-top: 8px;
			font-size: 26px;
			color: rgb(158, 158, 158);
			
		}
	}
}
</style>
